export default __webpack_public_path__ + "static/media/Corel.2a3371a4.png";